import { API_REQUEST } from "../..";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  hireTalentSignUpAPI,
  addCompanyDetailsAPI,
  hireTalentSection2API,
  hireTalentSection3API,
  hireTalentSection4API,
  hireTalentProfileAPI,
  hireTalentUpdateProfileStepAPI,
  addPostJobHireTalant,
  getMyPostJobListEndPointURL,
  updatePostJobHireTalant,
  deleteJobPostEndPointURL,
  raiseTicketAPI,
  getAllTicketsAPI,
  hireTalentJobApplicationsAPI,
  hireTalentJobApplicationProjectsAPI,
  hireTalentScheduleJobApplicationAPI,
  hireTalentRejectJobApplicationAPI,
  hireTalentMassRejectionEmailAPI,
  hireTalentDashboardAPI,
} from "../../../../routes/apiurls";

let hireTalentProfileInFlight = null;
let hireTalentProfileCache = null;
let hireTalentProfileCacheAt = 0;
const HIRE_TALENT_PROFILE_TTL_MS = 30 * 1000;

export const clearHireTalentProfileCache = () => {
  hireTalentProfileInFlight = null;
  hireTalentProfileCache = null;
  hireTalentProfileCacheAt = 0;
};

// hire-talent-sign-up
export const hireTalentSignUp = createAsyncThunk(
  "hire-talent-sign-up",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: hireTalentSignUpAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// add-company-details
export const addCompanyDetails = createAsyncThunk(
  "add-company-details",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: addCompanyDetailsAPI,
        method: "POST",
        data: payload,

        currentPanel: "hire-talent"
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// update-section-2
export const updateHireTalentSection2 = createAsyncThunk(
  "hire-talent-update-section-2",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: hireTalentSection2API,
        method: "POST",
        data: payload,
        currentPanel: "hire-talent",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// update-section-3
export const updateHireTalentSection3 = createAsyncThunk(
  "hire-talent-update-section-3",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: hireTalentSection3API,
        method: "POST",
        data: payload,
        isSuccessToast: false,
        currentPanel: "hire-talent",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// update-section-4
export const updateHireTalentSection4 = createAsyncThunk(
  "hire-talent-update-section-4",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: hireTalentSection4API,
        method: "POST",
        data: payload,
        currentPanel: "hire-talent",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// get hire-talent profile
export const fetchHireTalentProfile = createAsyncThunk(
  "hire-talent-profile",
  async (props) => {
    const { force = false } = props || {};
    const now = Date.now();

    if (!force && hireTalentProfileCache && now - hireTalentProfileCacheAt < HIRE_TALENT_PROFILE_TTL_MS) {
      return hireTalentProfileCache;
    }

    if (!force && hireTalentProfileInFlight) {
      return hireTalentProfileInFlight;
    }

    hireTalentProfileInFlight = API_REQUEST({
      url: hireTalentProfileAPI,
      method: "GET",
      currentPanel: "hire-talent",
    })
      .then((response) => {
        hireTalentProfileCache = response;
        hireTalentProfileCacheAt = Date.now();
        return response;
      })
      .catch(() => null)
      .finally(() => {
        hireTalentProfileInFlight = null;
      });

    return hireTalentProfileInFlight;
  }
);

// update hire-talent profile (multipart)
export const updateHireTalentProfileStep = createAsyncThunk(
  "hire-talent-update-profile-step",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: hireTalentUpdateProfileStepAPI,
        method: "POST",
        data: payload,
        headers: { "Content-Type": "multipart/form-data" },
        currentPanel: "hire-talent",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// Add Job Post
export const addJobPostByHireTalent = createAsyncThunk(
  "add-job-post-hire-talent",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: addPostJobHireTalant,
        method: "POST",
        data: payload,
        currentPanel: "hire-talent"
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// Update Job Post
export const updateJobPostByHireTalent = createAsyncThunk(
  "update-job-post-hire-talent",
  async (props) => {
    const { payload, callback, params } = props;
    try {
      const response = await API_REQUEST({
        url: `${updatePostJobHireTalant}${params}`,
        method: "PUT",
        data: payload,
        currentPanel: "hire-talent"
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// Delete Job Post
export const deleteJobPostByHireTalent = createAsyncThunk(
  "delete-job-post-hire-talent",
  async (props) => {
    const { callback, params } = props;
    try {
      const response = await API_REQUEST({
        url: `${deleteJobPostEndPointURL}${params}`,
        method: "DELETE",
        currentPanel: "hire-talent"
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);
// Get Job Post
export const getJobPostData = createAsyncThunk("get-post-job-hire-talent", async () => {
  try {
    const response = await API_REQUEST({
      url: getMyPostJobListEndPointURL,
      method: "GET",
      currentPanel: "hire-talent"
    });
    return response;
  } catch (error) { }
}
);

export const raiseHireTalentTicket = createAsyncThunk(
  "raise-hire-talent-ticket",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: raiseTicketAPI,
        method: "POST",
        data: payload,
        currentPanel: "hire-talent",
      });
      if (callback) callback(response);
      return response;
    } catch (error) {
      if (callback) callback(null, error);
    }
  }
);

export const fetchHireTalentTickets = createAsyncThunk(
  "fetch-hire-talent-tickets",
  async () => {
    try {
      const response = await API_REQUEST({
        url: getAllTicketsAPI,
        method: "GET",
        isSuccessToast: false,
        currentPanel: "hire-talent",
      });
      return response;
    } catch (error) { }
  }
);

export const fetchHireTalentJobApplications = createAsyncThunk(
  "fetch-hire-talent-job-applications",
  async (props = {}) => {
    const { project_id, tab = "all" } = props;
    const params = new URLSearchParams();
    if (project_id) params.append("project_id", String(project_id));
    if (tab) params.append("tab", String(tab));
    const queryString = params.toString();
    try {
      const response = await API_REQUEST({
        url: `${hireTalentJobApplicationsAPI}${queryString ? `?${queryString}` : ""}`,
        method: "GET",
        isSuccessToast: false,
        currentPanel: "hire-talent",
      });
      return response;
    } catch (error) { }
  }
);

export const fetchHireTalentApplicationProjects = createAsyncThunk(
  "fetch-hire-talent-application-projects",
  async () => {
    try {
      const response = await API_REQUEST({
        url: hireTalentJobApplicationProjectsAPI,
        method: "GET",
        isSuccessToast: false,
        currentPanel: "hire-talent",
      });
      return response;
    } catch (error) { }
  }
);

export const fetchHireTalentDashboard = createAsyncThunk(
  "fetch-hire-talent-dashboard",
  async () => {
    try {
      const response = await API_REQUEST({
        url: hireTalentDashboardAPI,
        method: "GET",
        isSuccessToast: false,
        currentPanel: "hire-talent",
      });
      return response;
    } catch (error) { }
  }
);

export const scheduleHireTalentInterview = createAsyncThunk(
  "schedule-hire-talent-interview",
  async (props) => {
    const { payload, params, callback } = props;
    try {
      const response = await API_REQUEST({
        url: `${hireTalentScheduleJobApplicationAPI}${params}/schedule`,
        method: "PUT",
        data: payload,
        currentPanel: "hire-talent",
      });
      if (callback) callback(response);
      return response;
    } catch (error) {
      if (callback) callback(null, error);
    }
  }
);

export const rejectHireTalentApplicant = createAsyncThunk(
  "reject-hire-talent-applicant",
  async (props) => {
    const { payload, params, callback } = props;
    try {
      const response = await API_REQUEST({
        url: `${hireTalentRejectJobApplicationAPI}${params}/schedule`,
        method: "PUT",
        data: payload,
        currentPanel: "hire-talent",
      });
      if (callback) callback(response);
      return response;
    } catch (error) {
      if (callback) callback(null, error);
    }
  }
);

export const updateHireTalentQuickApplicantStatus = createAsyncThunk(
  "update-hire-talent-quick-applicant-status",
  async (props) => {
    const { payload, params, callback } = props;
    try {
      const response = await API_REQUEST({
        url: `${hireTalentScheduleJobApplicationAPI}${params}/action`,
        method: "PUT",
        data: payload,
        isSuccessToast: false,
        currentPanel: "hire-talent",
      });
      if (callback) callback(response);
      return response;
    } catch (error) {
      if (callback) callback(null, error);
    }
  }
);

export const sendHireTalentMassRejectionEmail = createAsyncThunk(
  "send-hire-talent-mass-rejection-email",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: hireTalentMassRejectionEmailAPI,
        method: "POST",
        data: payload,
        isSuccessToast: false,
        currentPanel: "hire-talent",
      });
      if (callback) callback(response);
      return response;
    } catch (error) {
      if (callback) callback(null, error);
    }
  }
);

